<!-- <div class="post-list-container"> -->
<div class="post-list v2">
    <carousel *ngIf="!loading" [showControls]="false">
        <ng-container *ngFor="let item of items">
            <ng-container *carouselItem>
                <div class="item post">
                    <div class="post-thumbnail">
                        <div class="post-publishDate">
                            <div class="day">{{ item.publishDate | date: 'dd' }}</div>
                            <div class="month">{{ item.publishDate | date: 'MMM' }}</div>
                        </div>

                        <div class="post-image-container" [innerHtml]="item.image"></div>
                        <!-- {{item.image}}         -->
                        <!-- <img width="310" height="310" class="post-image" [src]="item.imageLink" data-src="{{item.imageLink}}" [alt]="item.imageAlt" [title]="item.imageTitle"> -->
                    </div>
                    <div class="post-content">
                        <div class="post-category">{{ item.category }}</div>
                        <a href="{{ item.link }}" class="post-link post-title">
                            <h1 class="post-title">
                            {{ item.title }}
                            </h1>
                        </a>
                        <!-- <h3 class="post-subtitle">
                            {{ item.title }}
                        </h3> -->
                        <!-- <div class="post-description" [innerHtml]="item.description"></div> -->
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </carousel>
</div>
<!-- </div> -->